"use strict";
exports.__esModule = true;
exports.UUIDUtils = void 0;
var UUIDUtils = /** @class */ (function () {
    function UUIDUtils() {
    }
    UUIDUtils.generate = function () {
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line: no-bitwise
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            // tslint:disable-next-line: no-bitwise // tslint:disable-next-line: triple-equals
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    };
    return UUIDUtils;
}());
exports.UUIDUtils = UUIDUtils;
